import SetupUsersBridge from './SetupUsersBridge';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';

angular
  .module('flowingly.runner.setup')
  .config(config)
  .component('setupUsers', SetupUsersBridge);

config.$inject = ['$stateProvider'];

function config($stateProvider) {
  $stateProvider.state(STATE_MAPPINGS.setupusers, {
    url: '/users',
    params: { flowId: null, title: 'Setup - Users' },
    views: {
      childcontent: {
        //if / when we upgrade to ui-router v1 this two controller lines can be replaced with
        //component: 'flowUsers',
        controllerAs: '$ctrl',
        controller: [
          '$state',
          'permissionsService',
          'flowinglyConstants',
          function ($state, permissionsService, flowinglyConstants) {
            if (
              !permissionsService.currentUserHasPermission(
                flowinglyConstants.permissions.SETUP_USER_ACCESS
              )
            ) {
              $state.go(STATE_MAPPINGS.flowsactive);
            }
          }
        ],
        template: '<flow-users></flow-users>'
      }
    }
  });
}
